import { FALLBACK_CURRENCY, numberOr } from "../checkout/money";
import { formatMoney } from "../orders/format";

export { FALLBACK_CURRENCY, formatMoney };

export const TOP_UP_CURRENCY = FALLBACK_CURRENCY;

export const parseAmount = (raw) => {
  const cleaned = String(raw ?? "").replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  const joined = parts.length > 1 ? `${parts[0]}.${parts.slice(1).join("")}` : parts[0];
  const parsed = Number(joined);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const sanitizeAmountInput = (raw) => {
  const cleaned = String(raw ?? "").replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");

  return parts.length > 1 ? `${parts[0]}.${parts.slice(1).join("")}` : parts[0];
};

export const moneyOf = (value, currency) => ({
  value: numberOr(value, 0),
  currency: currency || FALLBACK_CURRENCY,
});

export const formatAmountWith = (value, currency) => formatMoney(moneyOf(value, currency));

export const signMoney = (money, impact) =>
  `${impact === "C" ? "+" : "-"} ${formatMoney(money)}`;
